import css from 'styled-jsx/css';

export default css`
  .wrapper-info {
    padding: 40px;
    width: 100%;
    position: relative;
  }
  .wrapper-info h6,
  .wrapper-info h5 {
    text-align: center;
  }
  .wrapper-info h5 {
    font-size: 18px;
    margin-bottom: 4px;
  }
  .wrapper-info h6 {
    font-size: 16px;
    margin-bottom: 4px;
  }
  .wrapper-info :global(.button) {
    margin-top: 16px;
  }
  @media all and (max-width: 768px) {
    .wrapper-info .info-api {
      order: 2;
      margin-top: 20px;
    }
    .wrapper-info {
      padding: 20px;
    }
  }
  .wrapper-info:before {
    content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.2;
    background-image: url(/images/home/new/bg_prefooter.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
`;
